module.exports = __webpack_public_path__ + "static/media/01.00dc86e8.jpeg";